<template>

	<div class="header">
		<div class="container-fluid">
			<div class="header-body">
				<div class="row align-items-center mb-n4 pb-0">
					<div class="col mb-4">
						<!-- Title -->
						<h1 class="display-3 header-title">
							Performance
						</h1>
					</div>
				</div>
			</div><!--/.header-body-->
		</div><!--/.container-fluid-->
	</div><!--/.header-->

	<admin-performance-chart
		:project="this.project"
	></admin-performance-chart>

</template>

<script>
	import dayjs from 'dayjs';
	import AdminPerformanceChart from './AdminPerformanceChart.vue';

	export default {

		props: ['project'],

		components: {
			AdminPerformanceChart
		},

		data() {
			return {

			}
		},

		mounted() {

		},

		computed: {

		},

		methods: {

			// fetchPerformanceData() {
			// 	axios.get(this.creativeAssetEndpoint + '/media')
			// 		.then((response) => {

			// 			this.creativeAsset.media = response.data;

			// 			this.resetSelectedMedia();

			// 			if(this.isEmbeddableImage || this.isEmbeddableVideo) {
			// 				clearInterval(this.polling); // won't be polled anymore
			// 			}
			// 		})
			// 		.catch((error) => {
			// 			console.error(error);
			// 		});
			// },

			// resetPolling() {
			// 	clearInterval(this.polling);
			// 	if(!this.selectedMedia.embeddable && this.selectedMedia.processing_job_status != 'failed') {
			// 		this.polling = setInterval(() => {
			// 			this.fetchMedia()
			// 		}, 3000) // check every 3 seconds
			// 		setTimeout(() => { clearInterval(this.polling) }, 1000 * 60 * 30) //stop polling after 30 minutes
			// 	}
			// },

			// resetSelectedMedia() {
			// 	this.selectedMedia = this.creativeAsset.media[0];
			// },

			// openImageLightbox(el) {
			// 	BigPicture({
			// 		el: document.querySelector(el),
			// 		imgSrc: this.selectedMedia.embeddable.url,
			// 		noLoader: true,
			// 	});
			// },

			// openVideoLightbox(el) {
			// 	BigPicture({
			// 		el: document.querySelector(el),
			// 		vidSrc: this.selectedMedia.embeddable.url,
			// 		noLoader: true,
			// 	});
			// },

			// formatDate(date) {
			// 	return dayjs(date).format('MMM D, YYYY h:mma');
			// },

			// formatBytes(bytes, decimals = 0) {
			// 	if (bytes === 0) return '0 bytes';
			// 	const k = 1024;
			// 	const dm = decimals < 0 ? 0 : decimals;
			// 	const sizes = ['bytes', 'kb', 'mb', 'gb', 'tb', 'pb', 'eb', 'zb', 'yb'];
			// 	const i = Math.floor(Math.log(bytes) / Math.log(k));
			// 	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
			// },

			// nl2br(str, is_xhtml) {
			// 	var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />'   : '<br>';
			// 	return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag   + '$2');
			// },

			// linkify(text) {
			// 	var urlRegex = /(https?:\/\/[^\s]+)/g;
			// 	return text.replace(urlRegex, function(url) {
			// 		return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
			// 	});
			// },

			// strLimit(str, length) {
			// 	if(str.length <= length) {
			// 		return str;
			// 	}

			// 	return str.substring(0, length) + "...";
			// }

		}

		// beforeDestroy () {
		// 	clearInterval(this.polling);
		// }
	}

</script>
